import React, { useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { AccordionDetails } from 'components/customer-details/tables/StyledAccordian'
import { Box, Divider, useTheme } from '@mui/material'
import T from 'T'
import LateFeeAccordionItem from 'components/customer-details/content/fees/late_fees/LateFeesCustomerAccordionItem'
import AddLateFeesDialog from 'components/customer-details/content/fees/late_fees/AddLateFeesDialog/AddLateFeesDialog'
import { HHAlert } from 'components/common/HHAlert'
import { useLazyFetchAccountLateFeesQuery } from 'api/pricing/lateFeesCrud'
import { get } from 'lodash'
import HHAccordion from 'components/common/HHAccordion'
import LateFeesCustomerAccordionItemSkeleton from 'components/customer-details/content/fees/late_fees/AddLateFeesDialog/LateFeesAccordionItemSkeleton'

const LateFeesAccordion = ({ customerDetails }) => {
  const theme = useTheme()
  const shimmersArray = new Array(5).fill(0)
  const [isAddLateFeesDialogOpen, setIsAddLateFeesDialogOpen] = useState(false)
  const accountId = useMemo(() => get(customerDetails, 'id'), [])
  const [fetchAccountLateFees, { isLoading, data, isFetching }] = useLazyFetchAccountLateFeesQuery()
  const loading = useMemo(() => isFetching || isLoading, [isFetching, isLoading])
  const lateFees = get(data, 'lateFees', [])
  const hasLateFees = useMemo(() => lateFees.length > 0, [lateFees])
  const openAddLateFeeDialog = () => {
    setIsAddLateFeesDialogOpen(true)
  }

  const closeAddLateFeeDialog = () => {
    setIsAddLateFeesDialogOpen(false)
  }

  useEffect(() => {
    if (accountId) {
      fetchAccountLateFees({ accountId })
    }
  }, [accountId])

  return (
    <>
      <HHAccordion
        elevation={0}
        actionType="add"
        onActionClick={openAddLateFeeDialog}
        withNewColors
        isExpanded
        iconGap={false}
        summary={`${T.LATE}`}
      >
        <AccordionDetails>
          <Box
            width="100%"
            sx={{
              ...(!hasLateFees && {
                p: 2,
              }),
            }}
          >
            {loading && shimmersArray.map(() => <LateFeesCustomerAccordionItemSkeleton />)}
            {!loading && (
              <>
                {!hasLateFees && (
                  <HHAlert
                    severity="info"
                    borderColor={theme.palette.info.main}
                    sx={{
                      justifyContent: 'center',
                      p: 2,
                    }}
                  >
                    No late fees on this account yet
                  </HHAlert>
                )}
                {lateFees.map(lateFee => {
                  return (
                    <>
                      <LateFeeAccordionItem {...lateFee} accountId={accountId} />
                      <Divider />
                    </>
                  )
                })}
              </>
            )}
          </Box>
        </AccordionDetails>
      </HHAccordion>
      <AddLateFeesDialog open={isAddLateFeesDialogOpen} onClose={closeAddLateFeeDialog} accountId={accountId} />
    </>
  )
}

LateFeesAccordion.propTypes = {
  initialTab: PropTypes.string,
  customerDetails: PropTypes.object,
}

export default LateFeesAccordion
